import { advance, type GuideEvent } from "./guide.js";
import {
  PHOTO_QUOTA,
  type DemoBrand,
  type DemoGuest,
  type DemoPhoto,
  type DemoState,
} from "./types.js";

export type DemoAction =
  | { readonly type: "brand-created"; readonly brand: DemoBrand }
  | { readonly type: "invite-opened" }
  | { readonly type: "guest-joined"; readonly guest: DemoGuest }
  | { readonly type: "photo-sent"; readonly photo: DemoPhoto }
  | { readonly type: "photo-hidden"; readonly id: string }
  | { readonly type: "photo-shown"; readonly id: string }
  | { readonly type: "wall-seen" }
  | { readonly type: "album-seen" }
  | { readonly type: "tip-seen" }
  | { readonly type: "guide-toggled" };

function guided(state: DemoState, event: GuideEvent): DemoState {
  return { ...state, guide: advance(state.guide, event, state.audience) };
}

export function reduce(state: DemoState, action: DemoAction): DemoState {
  switch (action.type) {
    case "brand-created":
      return guided({ ...state, brand: action.brand }, "brand-created");
    case "invite-opened":
      return guided(state, "invite-opened");
    case "guest-joined":
      return guided({ ...state, guest: action.guest }, "guest-joined");
    case "photo-sent":
      return state.photos.length >= PHOTO_QUOTA
        ? state
        : guided({ ...state, photos: [...state.photos, action.photo] }, "photo-sent");
    case "photo-hidden":
      return guided(
        state.hidden.includes(action.id)
          ? state
          : { ...state, hidden: [...state.hidden, action.id] },
        "photo-hidden",
      );
    case "photo-shown":
      return { ...state, hidden: state.hidden.filter((id) => id !== action.id) };
    case "wall-seen":
      return guided(state, "wall-seen");
    case "album-seen":
      return guided(state, "album-seen");
    case "tip-seen":
      return { ...state, tipSeen: true };
    case "guide-toggled":
      return { ...state, guide: { ...state.guide, collapsed: !state.guide.collapsed } };
  }
}
